import { wkSign } from '@/utils/http/modules/mine/mine.request'
import commonAjax from '@/utils/http/modules/common.request.js'
import router from '@/router/router'
import { getLocal, setLocal } from '@/utils/utils'

export function wxShareData(shareSide) {
  // 分享给朋友
  window.wx.onMenuShareAppMessage({
    title: shareSide.title, //  分享标题
    desc: shareSide.descript, // 分享描述
    link: shareSide.shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: shareSide.imgurl, // 分享图标'
    type: 'link', // 分享类型,music、video或link，不填默认为link
    dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
  })
  // 分享到朋友圈
  window.wx.onMenuShareTimeline({
    title: shareSide.title, // 分享标题
    link: shareSide.shareurl, // 分享链接
    imgUrl: shareSide.imgurl, // 分享图标
  })
  // 分享到QQ
  window.wx.onMenuShareQQ({
    title: shareSide.title, // 分享标题
    desc: shareSide.descript, // 分享描述
    link: shareSide.shareurl, // 分享链接
    imgUrl: shareSide.imgurl, // 分享图标
  })
  // 分享到腾讯微博
  window.wx.onMenuShareWeibo({
    title: shareSide.title, // 分享标题
    desc: shareSide.descript, // 分享描述
    link: shareSide.shareurl, // 分享链接
    imgUrl: shareSide.imgurl, // 分享图标
  })
  // 分享到QQ空间
  window.wx.onMenuShareQZone({
    title: shareSide.title, // 分享标题
    desc: shareSide.descript, // 分享描述
    link: shareSide.shareurl, // 分享链接
    imgUrl: shareSide.imgurl, // 分享图标
  })
  window.wx.updateAppMessageShareData({
    title: shareSide.title, //  分享标题
    desc: shareSide.descript, // 分享描述
    link: shareSide.shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: shareSide.imgurl, // 分享图标
  })
  window.wx.updateTimelineShareData({
    title: shareSide.title, //  分享标题
    desc: shareSide.descript, // 分享描述
    link: shareSide.shareurl, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
    imgUrl: shareSide.imgurl, // 分享图标
  })
  window.wx.showOptionMenu()
}

/**
 * 获取微信签名
 * @param options InitWXSDK方法所需参数(可选)
 * @returns {Promise<void>}
 */
export async function getWeChatSignature(options = {}) {
  const {
    dataObj: { appid, noncestr, signature, timestamp },
  } = await commonAjax.getWeChatSignature({
    zbid: window.zbvd.zbid,
  })
  InitWXSDK({
    ...options,
    config: {
      appid,
      timestamp,
      noncestr,
      signature,
    },
  }).then(() => {})
}

export default function InitWXSDK(options) {
  console.log('InitWXSDK', options)
  console.log('router.currentRoute', router.currentRoute)
  return new Promise((resolve, reject) => {
    window.wx.config({
      debug: false,
      appId: options.config.appid,
      timestamp: options.config.timestamp,
      nonceStr: options.config.noncestr,
      signature: options.config.signature,
      jsApiList: [
        'checkJsApi',
        'onMenuShareTimeline',
        'selectExternalContact',
        'openUserProfile',
        'onMenuShareAppMessage',
        'onMenuShareQQ',
        'onMenuShareQZone',
        'onMenuShareWeibo',
        'hideMenuItems',
        'showMenuItems',
        'hideAllNonBaseMenuItem',
        'showAllNonBaseMenuItem',
        'translateVoice',
        'startRecord',
        'stopRecord',
        'onRecordEnd',
        'playVoice',
        'pauseVoice',
        'stopVoice',
        'uploadVoice',
        'downloadVoice',
        'chooseImage',
        'previewImage',
        'uploadImage',
        'downloadImage',
        'getNetworkType',
        'openLocation',
        'getLocation',
        'hideOptionMenu',
        'showOptionMenu',
        'closeWindow',
        'scanQRCode',
        'chooseWXPay',
        'openProductSpecificView',
        'addCard',
        'chooseCard',
        'openCard',
        'openAddress',
        'updateAppMessageShareData',
      ],
      openTagList: [
        'wx-open-launch-weapp',
        'wx-open-subscribe',
        'wx-open-launch-app',
      ],
    })
    window.wx.ready(async () => {
      if (options.isshare && !router.currentRoute.meta.isNotShare) {
        console.log('开启分享菜单', router.currentRoute.name)
        console.log('options.shareData', options.shareData)
        wxShareData(options.shareData)
        console.log('isshareTrue')
        if (options.menus) {
          window.wx.hideMenuItems({
            menuList: options.menus,
          })
        }
      } else {
        console.log('禁用分享菜单', router.currentRoute.name)
        window.wx.hideOptionMenu({
          success: function () {
            // 隐藏成功后执行的代码
            console.log('hideOptionMenu success')
          },
          fail: function () {
            // 隐藏失败后执行的代码
            console.log('hideOptionMenu fail')
            window.wx.hideOptionMenu()
          },
          complete: function () {
            // 隐藏完成后执行的代码，无论成功或者失败都会执行
            console.log('hideOptionMenu complete')
          },
        })
        console.log('禁用分享菜单结束', router.currentRoute.name)
      }
      console.log('inshowLoad2')
      resolve('res1')
    })
    window.wx.error(res => {
      reject(res || 'WX SDk loaded failed')
    })
  })
}

// 企业微信sdk
export async function initWxWorkSdk(apiList) {
  apiList = apiList || [
    'sendChatMessage',
    'getCurExternalContact',
    'getContext',
    'selectExternalContact',
    'openEnterpriseChat',
    'scanQRCode',
    'getCurExternalChat',
  ]
  const res = await wkSign({
    zbid: window.zbvd.zbid,
    url: location.href,
    cpid: window.corpId,
  })
  const config = res.dataObj
  const jsApiList = [
    'selectEnterpriseContact',
    'openUserProfile',
    'onMenuShareAppMessage',
    'onMenuShareWechat',
    'onMenuShareTimeline',
    'shareAppMessage',
    'shareWechatMessage',
    'scanQRCode',
    'chooseInvoice',
    'chooseImage',
    'previewImage',
    'uploadImage',
    'showOptionMenu',
    'hideOptionMenu',
  ]
  // const pcLsApiList = ['selectExternalContact', 'openUserProfile']
  return new Promise((resolve, reject) => {
    wx.config({
      beta: true, // 必须这么写，否则wx.invoke调用形式的jsapi会有问题
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: config.corpid, // 必填，企业微信的corpID
      timestamp: config.agentConfigTime, // 必填，生成签名的时间戳
      nonceStr: config.agentConfigNoncestr, // 必填，生成签名的随机串
      signature: config.agentconfigsignature, // 必填，签名，见 附录-JS-SDK使用权限签名算法
      jsApiList, // 必填，需要使用的JS接口列表，凡是要调用的接口都需要传进来
    })
    wx.ready(async () => {
      console.log('wx ready')
      try {
        await agentConfig(config, apiList)
        resolve()
      } catch (e) {
        reject(e)
      }
    })
    wx.error(error => {
      console.log('WX SDk loaded failed', error)
      // reject(error)
    })
  })
}

export function agentConfig(config, jsApiList) {
  return new Promise((resolve, reject) => {
    wx.agentConfig({
      corpid: config.corpid, // 必填，企业微信的corpid，必须与当前登录的企业一致
      agentid: config.agentid, // 必填，企业微信的应用id （e.g. 1000247）
      timestamp: config.agentConfigTime, // 必填，生成签名的时间戳
      nonceStr: config.agentConfigNoncestr, // 必填，生成签名的随机串
      signature: config.agentconfigsignature, // 必填，签名，见附录1
      jsApiList, // 必填
      success() {
        console.log('agentconfig success')
        localStorage.removeItem('retry_agentconfig')
        resolve()
        if (WWOpenData.on) {
          // ww-open-data 元素数据发生变更时触发
          WWOpenData.on('update', function (event) {
            var openid = event.detail.element.getAttribute('openid')
            console.info('渲染数据发生变更', openid, event.detail.hasData)
          })
          /**
           * ww-open-data 获取数据失败时触发
           */
          WWOpenData.on('error', function (event) {
            console.log('获取数据失败')
            console.log(event)
          })
        }
        WWOpenData.bindAll(document.querySelectorAll('ww-open-data'))
      },
      fail: function (res) {
        console.log('agentconfig fail', res)
        let getRetry = getLocal('retry_agentconfig') || 0
        if (!getRetry || getRetry < 5) {
          setLocal('retry_agentconfig', ++getRetry)
          initWxWorkSdk()
        }
        reject()
        if (res.errMsg.indexOf('function not exist') > -1) {
          alert('版本过低请升级')
        }
      },
    })
  })
}
